import React, { useEffect, useRef } from "react";
import { Terminal } from "lucide-react";

export default function ScanTerminal({ logs, percent }) {
  const endRef = useRef(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [logs]);

  const barWidth = 28;
  const filled = Math.round((percent / 100) * barWidth);
  const bar = "█".repeat(filled) + "░".repeat(barWidth - filled);

  return (
    <div className="border border-zinc-800" data-testid="scan-terminal">
      <div className="flex items-center gap-2 bg-zinc-800 px-4 py-2">
        <Terminal className="h-3.5 w-3.5 text-green-400" />
        <span className="font-mono text-xs text-zinc-300 tracking-wide">insight-agent — live</span>
        <div className="ml-auto flex gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-zinc-600" />
          <span className="h-2.5 w-2.5 rounded-full bg-zinc-600" />
          <span className="h-2.5 w-2.5 rounded-full bg-green-500" />
        </div>
      </div>
      <div className="bg-zinc-900 text-green-400 p-5 font-mono text-[13px] h-[360px] overflow-y-auto thin-scroll">
        {logs.map((l, i) => (
          <div key={i} className="leading-relaxed">
            <span className="text-zinc-600">{">"}</span> {l.msg}
          </div>
        ))}
        <div className="cursor-blink inline-block">
          <span className="text-zinc-600">{">"}</span> _
        </div>
        <div ref={endRef} />
      </div>
      <div className="bg-zinc-900 border-t border-zinc-800 px-5 py-3 font-mono text-[13px] text-green-400 flex items-center gap-3">
        <span>[{bar}]</span>
        <span className="text-white">{percent}%</span>
      </div>
    </div>
  );
}
